export const DEFUALT_PERCENT = '100';
export const MAX_VALUE = 9007199254740991;
